import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, ContactPage } from "@/components/features/contact";
import SEO from "@/components/common/seo/seo";

export default function ItServicePackage() {
    return (
        <div>
            <SEO
                title="Contact Us - SAN micron"
                description="Empowering businesses through seamless technology and exceptional service, one conversation at a time."
            />
            <Breadcrumbs />
            <ContactPage />
            <div className="abstract-bg">
                {/* <FAQ /> */}
            </div>
            <Footer />
        </div>
    );
}